const util = require('./calc_time');

const calc_times = (config, medication_count,first_drug_date, medication_cycle_days) => {
    let latest_time = Date.parse(first_drug_date);
    let latest_num = Number(medication_count);
    if (!latest_num || latest_num == 0) return null;

    if (config.cal_base == 'COUNT') {
        let count = Number(config.default_count);
        let cycle = parseInt(Number(latest_num) / count);
        let days = Number(medication_cycle_days);
        latest_time = latest_time + cycle * 3600 * 24 * 1000 * days;

        return {
            medication_cycle: (medication_count / count),
            medication_count: medication_count,
            next_medication_date: util.formatTime(new Date(latest_time)).time1
        }
    }
    if (config.cal_base == 'TIME') {
        let cycle = 1;
        if (cycle === 0) return null;

        let days = medication_cycle_days;

        latest_time = latest_time + 3600 * 24 * 1000 * Number(days);

        return {
            medication_cycle: cycle,
            medication_count: latest_num,
            next_medication_date: util.formatTime(new Date(latest_time)).time1
        }
    }
};
const calc_times_2 = (cycle_type,
                      default_count,
                      medication_count,
                      first_drug_date,
                      medication_cycle_days,
                      now_drug_date,
                      old_cycle) => {
    let first_time = first_drug_date ? Date.parse(first_drug_date) : '';
    let now_time = now_drug_date ? Date.parse(now_drug_date) : '';
    let latest_time = now_time || first_time;
    // console.log(latest_time,first_drug_date,now_drug_date, '48');

    let latest_num = Number(medication_count);
    if (!latest_num || latest_num == 0) return null;

    let count = Number(default_count);

    let cycle = Math.ceil(Number(latest_num) / count);
    if(cycle_type === 'time') {
        cycle = 1
    }

    let days = Number(medication_cycle_days);

    latest_time = latest_time + cycle * 3600 * 24 * 1000 * days;

    if(now_time && first_time) {
        let last_cycle = Math.ceil((now_time - first_time) / (1000*3600*24*days));
        console.log(last_cycle, '51');
        cycle = last_cycle + cycle
    }
    if(now_time && old_cycle) {
        cycle = cycle + Number(old_cycle)
    }

    return {
        medication_cycle: cycle,
        medication_count: latest_num,
        next_medication_date: util.formatTime(new Date(latest_time)).time1
    }
};


module.exports = {
    calc_times,
    calc_times_2
}